import { IService } from '../../infrastructure';
import request from '../request';
import { AxiosResponse } from 'axios';
import {
  ISocialMediaData,
  ISocialMediaFormData,
  IUpdateChildVisibilityReq,
  IUpdateProfileImageReq,
  IUpdateProfileInfoReq,
  IUpdateProfileVisibilityReq,
  IUserInfo,
  IUserInfoRes,
} from './type';

export const getProfile = async (): Promise<IUserInfo[]> => {
  const data: IService = {
    method: 'GET',
    relativePath: 'trust/get-user-info',
  };
  const response =
    await request.requestService<AxiosResponse<IUserInfo[]>>(data);
  return response.data;
};

export const getUserProfileInfo = async (): Promise<IUserInfoRes> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile-edit',
  };

  const response =
    await request.requestService<AxiosResponse<IUserInfoRes>>(data);

  return response.data;
};

export const updateChildrenVisible = async (
  requestDate: IUpdateChildVisibilityReq,
): Promise<any> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/update-visibility-children',
    data: {
      profile_id: requestDate.profile_id,
      children_visibility: requestDate.children_visibility,
    },
  };

  const response = await request.requestService<AxiosResponse<any>>(data);

  return response.data;
};

export const updateChildrenProfile = async (
  requestDate: IUpdateProfileVisibilityReq,
): Promise<any> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/update-visibility-profile',
    data: {
      profile_id: requestDate.profile_id,
      profile_visibility: requestDate.profile_visibility,
    },
  };

  const response = await request.requestService<AxiosResponse<any>>(data);

  return response.data;
};

export const updatePassword = async (password: string): Promise<any> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/change-password',
    data: {
      new_password: password,
    },
  };
  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};

export const getSocialMediaData = async (): Promise<ISocialMediaData[]> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/socialmedia-list',
  };
  const response =
    await request.requestService<AxiosResponse<ISocialMediaData[]>>(data);
  return response.data;
};

export const updateProfileImage = async (
  requestData: IUpdateProfileImageReq,
): Promise<any> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/update-profile-image',
    data: {
      profile_id: requestData.profile_id,
      photo: requestData.photo,
    },
  };

  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};

export const updateProfileSocialMedia = async (
  requestData: ISocialMediaFormData,
): Promise<any> => {
  const data: IService = {
    method: 'POST',
    relativePath: '/profile/insert_sociallinks',
    data: requestData,
  };
  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};

export const updateProfileInfo = async (
  requestData: IUpdateProfileInfoReq,
): Promise<any> => {
  const data: IService = {
    method: 'post',
    relativePath: '/profile/update-profile-info',
    data: requestData,
  };

  const response = await request.requestService<AxiosResponse<any>>(data);
  return response.data;
};
